import { ActionTypes as types } from 'constants';

const initialState = {
  data: {},
  isLoaded: false,
  isFetching: false,
};

const fitness = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FETCH_STRAVA_STATUS:
      return { ...state, isLoaded: false, isFetching: true };
    case types.FETCH_STRAVA_STATUS_SUCCESS:
      return {
        data: { ...action.payload },
        isLoaded: true,
        isFetching: false,
      };
    case types.FETCH_STRAVA_STATUS_FAILURE:
      return { ...state, isLoaded: true, isFetching: false };
    case types.UNLINK_STRAVA_SUCCESS:
      return {
        ...state,
        data: { ...state.data, isConnected: false },
      };
    default:
      return state;
  }
};

export default fitness;
